var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "story-maker-sticker-menu-link" }, [
    _c("div", { staticClass: "header-menu" }, [
      _c("p", [_vm._v(_vm._s(_vm.$t("dash.post-creator.story.link-title")))]),
    ]),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "form" }, [
        _c("div", { staticClass: "container-input" }, [
          _c("div", { staticClass: "input input-link" }, [
            _c("i", { staticClass: "fa-regular fa-link" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.models.link,
                  expression: "models.link",
                },
              ],
              attrs: {
                placeholder: _vm.$t("dash.post-creator.story.url-placeholder"),
              },
              domProps: { value: _vm.models.link },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.models, "link", $event.target.value)
                },
              },
            }),
          ]),
          _c("div", { staticClass: "url-length-info" }, [
            _vm.isOverLimit
              ? _c("p", { staticClass: "url-length-warning" }, [
                  _vm._v(
                    _vm._s(_vm.$t("dash.post-creator.story.link-url-too-long"))
                  ),
                ])
              : _vm.hasBitlyToken && _vm.models.link.length > 245
              ? _c("p", { staticClass: "url-length-info-bitly" }, [
                  _vm._v(
                    _vm._s(_vm.$t("dash.post-creator.story.link-url-bitly"))
                  ),
                ])
              : _vm._e(),
            _c(
              "span",
              {
                staticClass: "url-length-count",
                class: { "at-limit": _vm.isOverLimit },
              },
              [_vm._v(_vm._s(_vm.models.link.length) + "/245")]
            ),
          ]),
          _c("p", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))]),
        ]),
        !_vm.showEditText
          ? _c(
              "p",
              {
                staticClass: "add-text",
                on: { click: _vm.toggleDisplayAddText },
              },
              [
                _c("i", { staticClass: "fa-solid fa-plus" }),
                _vm._v(
                  " " + _vm._s(_vm.$t("dash.post-creator.story.link-add-text"))
                ),
              ]
            )
          : _c(
              "p",
              {
                staticClass: "add-text",
                on: { click: _vm.toggleDisplayAddText },
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("dash.post-creator.story.link-remove-text"))
                ),
              ]
            ),
        _vm.showEditText
          ? _c("div", { staticClass: "container-input" }, [
              _c("div", { staticClass: "input input-text" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.models.text,
                      expression: "models.text",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "dash.post-creator.story.link-sticker-text-placeholder"
                    ),
                  },
                  domProps: { value: _vm.models.text },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.models, "text", $event.target.value)
                    },
                  },
                }),
              ]),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        {
          staticClass: "button",
          class: { disable: _vm.isOverLimit },
          on: { click: _vm.finish },
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("dash.post-creator.story.add-button")) +
              "\n        "
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }